export const SET_ABMUSTERUNGGRUENDE = 'set_abmusterunggruende';
export const SET_ABMUSTERUNGGRUENDE_LOADED = 'set_abmusterunggruende_loaded';
export const SET_ABMUSTERUNGABTEILUNGEN = 'set_abmusterungabteilungen';
export const SET_ABMUSTERUNGABTEILUNGEN_LOADED = 'set_abmusterungabteilungen_loaded';

export const SET_ABMUSTERUNGSTATI = 'set_abmusterungstati';
export const SET_ABMUSTERUNGSTATI_LOADED = 'set_abmusterungstati_loaded';

export const SET_STATISTIK_ABTEILUNGEN = 'set_statistik_abteilungen';
